import { FC, useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';
import Form from 'components/form/Form';
import FormGroup from 'components/form/FormGroup';

interface IProps {
  methods: any;
  data: any;
  onSubmit: (data: any) => void;
}

interface IDataType {
  [key: string]: string | number | boolean;
}

const ReportForm: FC<IProps> = ({ methods, data, onSubmit }) => {
  const { t } = useTranslation();
  const [employees, setEmployees] = useState(data?.user || []);

  useEffect(() => {
    // Set default date range
    methods.setValue('date_from', new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    methods.setValue('date_to', new Date());
  }, [data, methods]);

  const groups = methods.watch('group');

  useEffect(() => {
    const groupIds = groups?.map((gr: any) => gr.value);

    if (groupIds) {
      const filteredEmployees = data?.user.filter((empl: any) => {
        if (!empl.groups.length) return groupIds.includes('null');

        return empl.groups.some((groupId: number) => groupIds.includes(groupId));
      });

      setEmployees(filteredEmployees);
      methods.setValue('user', filteredEmployees);
    } else {
      setEmployees(data?.user);
      methods.setValue('user', null);
    }
  }, [groups, data, methods]);

  return (
    <Form
      methods={methods}
      btnLabel={t('healthAndSafetyTraining.downloadReport')}
      hideCancelBtn
      onSubmit={onSubmit}
    >
      <Row>
        <Col
          md={{
            offset: 2,
            span: 8,
          }}
        >
          <FormGroup
            controlId="formGroupEmployees"
            label={t('healthAndSafetyTraining.users')}
            type="select"
            as="select"
            name="user"
            isMulti
            isClearable
            isSearchable
            allowSelectAll
            showTotal
            limitOptions
            selectOptions={employees}
          />
        </Col>
      </Row>
      <Row>
        <Col
          md={{
            offset: 2,
            span: 4,
          }}
        >
          <FormGroup
            controlId="formGroupGroups"
            label={t('healthAndSafetyTraining.groups')}
            type="select"
            as="select"
            name="group"
            isMulti
            isClearable
            isSearchable
            allowSelectAll
            selectOptions={data?.group}
          />
        </Col>
        <Col md={4}>
          <FormGroup
            controlId="formGroupType"
            label={t('healthAndSafetyTraining.type')}
            type="select"
            as="select"
            name="type"
            isMulti
            isClearable
            isSearchable
            allowSelectAll
            selectOptions={data?.type}
          />
        </Col>
      </Row>
      <Row>
        <Col
          md={{
            offset: 2,
            span: 4,
          }}
        >
          <FormGroup
            {...methods.register('date_from')}
            controlId="formGroupFromDate"
            label={t('reports.fromDate')}
            type="datepicker"
            name="date_from"
            dateFormat="dd.MM.yyyy"
            showMonthDropdown
            showYearDropdown
            isRequired
          />
        </Col>
        <Col md={4}>
          <FormGroup
            controlId="formGroupToDate"
            label={t('reports.toDate')}
            type="datepicker"
            name="date_to"
            dateFormat="dd.MM.yyyy"
            showMonthDropdown
            showYearDropdown
            isRequired
          />
        </Col>
      </Row>
    </Form>
  );
};

export default ReportForm;
